(() => {
  if(!window.location.pathname.includes('/products/wood-therapy-massage-set')) return;
  if(new URLSearchParams(window.location.search).get('pieces')) return;
  let tries = 0;
  const timer = window.setInterval(() => {
    tries++;
    const card = document.querySelector('#AurekoBundlePicker .aureko-bundle-card[data-pieces="6"]');
    const grid = document.getElementById('AurekoToolGrid');
    if(card && grid){
      window.clearInterval(timer);
      if(!card.classList.contains('is-selected') && card.dataset.available !== 'false') card.click();
    }
    if(tries > 40) window.clearInterval(timer);
  }, 150);
})();
